export const paths = {
    'home': '/',
    'services': '/services',
    'shop': '/shop',
    'contact': '/contact',
    'cart': '/cart',

    'reviews': '/reviews',
    'writeReview': '/write-review',

    'undefined': '*'
}